// @generated by protobuf-ts 2.9.4 with parameter generate_dependencies,optimize_code_size
// @generated from protobuf file "backend/v1/family.proto" (package "backend.v1", syntax proto3)
// tslint:disable
import { MessageType } from "@protobuf-ts/runtime";
import { DefaultChange } from "../../core/v1/value_source";
import { FieldError } from "../../core/v1/value_source";
import { PlanJob } from "./plan";
import { PlanRefreshAnswers } from "../../core/v1/questionnaire";
import { Questionnaire } from "../../core/v1/questionnaire";
import { Timestamp } from "../../google/protobuf/timestamp";
import { Family } from "../../core/v1/family";
/**
 * The household as one versioned document (architecture-redesign.md item D).
 *
 * @generated from protobuf message backend.v1.FamilyDocument
 */
export interface FamilyDocument {
    /**
     * @generated from protobuf field: core.v1.Family family = 1;
     */
    family?: Family;
    /**
     * @generated from protobuf field: int32 version = 2;
     */
    version: number; // incremented on every save; send it back as expected_version
    /**
     * @generated from protobuf field: int32 schema_version = 3;
     */
    schemaVersion: number;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4;
     */
    updatedAt?: Timestamp;
}
/**
 * POST /api/family/questionnaire: onboarding, Update Data, Sharpen. The engine merges the answers
 * (ApplyQuestionnaire); the backend saves the result and queues a plan job.
 *
 * @generated from protobuf message backend.v1.SaveQuestionnaireRequest
 */
export interface SaveQuestionnaireRequest {
    /**
     * @generated from protobuf field: core.v1.Questionnaire questionnaire = 1;
     */
    questionnaire?: Questionnaire;
    /**
     * The FamilyDocument.version the client edited; 0 when creating the household. A save against a
     * newer version is rejected with 409 and a VersionConflict body.
     *
     * @generated from protobuf field: int32 expected_version = 2;
     */
    expectedVersion: number;
}
/**
 * POST /api/family/check-in: the plan-refresh check-in (ApplyPlanRefresh).
 *
 * @generated from protobuf message backend.v1.SubmitCheckInRequest
 */
export interface SubmitCheckInRequest {
    /**
     * @generated from protobuf field: core.v1.PlanRefreshAnswers answers = 1;
     */
    answers?: PlanRefreshAnswers;
    /**
     * @generated from protobuf field: int32 expected_version = 2;
     */
    expectedVersion: number;
}
/**
 * @generated from protobuf message backend.v1.SaveFamilyResponse
 */
export interface SaveFamilyResponse {
    /**
     * @generated from protobuf field: backend.v1.FamilyDocument document = 1;
     */
    document?: FamilyDocument;
    /**
     * @generated from protobuf field: backend.v1.PlanJob plan_job = 2;
     */
    planJob?: PlanJob; // the plan job queued for this version
}
/**
 * 409 body for a version conflict.
 *
 * @generated from protobuf message backend.v1.VersionConflict
 */
export interface VersionConflict {
    /**
     * @generated from protobuf field: backend.v1.FamilyDocument current = 1;
     */
    current?: FamilyDocument;
}
/**
 * 422 body when the engine rejects the answers.
 *
 * @generated from protobuf message backend.v1.ValidationFailure
 */
export interface ValidationFailure {
    /**
     * @generated from protobuf field: repeated core.v1.FieldError errors = 1;
     */
    errors: FieldError[];
    /**
     * @generated from protobuf field: string message = 2;
     */
    message: string;
}
/**
 * GET /api/family/defaults: the defaults pass on the stored family (forms, Sharpen).
 *
 * @generated from protobuf message backend.v1.FamilyDefaultsResponse
 */
export interface FamilyDefaultsResponse {
    /**
     * @generated from protobuf field: core.v1.Family resolved_family = 1;
     */
    resolvedFamily?: Family; // user facts plus defaults; nothing calculated
    /**
     * @generated from protobuf field: repeated string defaulted_paths = 2;
     */
    defaultedPaths: string[];
    /**
     * @generated from protobuf field: repeated core.v1.DefaultChange default_changes = 3;
     */
    defaultChanges: DefaultChange[];
    /**
     * @generated from protobuf field: repeated core.v1.FieldError validation_errors = 4;
     */
    validationErrors: FieldError[];
    /**
     * @generated from protobuf field: repeated string engine_created_paths = 5;
     */
    engineCreatedPaths: string[];
    /**
     * @generated from protobuf field: int32 family_version = 6;
     */
    familyVersion: number;
}
// @generated message type with reflection information, may provide speed optimized methods
class FamilyDocument$Type extends MessageType<FamilyDocument> {
    constructor() {
        super("backend.v1.FamilyDocument", [
            { no: 1, name: "family", kind: "message", T: () => Family },
            { no: 2, name: "version", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "schema_version", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message backend.v1.FamilyDocument
 */
export const FamilyDocument = new FamilyDocument$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SaveQuestionnaireRequest$Type extends MessageType<SaveQuestionnaireRequest> {
    constructor() {
        super("backend.v1.SaveQuestionnaireRequest", [
            { no: 1, name: "questionnaire", kind: "message", T: () => Questionnaire },
            { no: 2, name: "expected_version", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message backend.v1.SaveQuestionnaireRequest
 */
export const SaveQuestionnaireRequest = new SaveQuestionnaireRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SubmitCheckInRequest$Type extends MessageType<SubmitCheckInRequest> {
    constructor() {
        super("backend.v1.SubmitCheckInRequest", [
            { no: 1, name: "answers", kind: "message", T: () => PlanRefreshAnswers },
            { no: 2, name: "expected_version", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message backend.v1.SubmitCheckInRequest
 */
export const SubmitCheckInRequest = new SubmitCheckInRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SaveFamilyResponse$Type extends MessageType<SaveFamilyResponse> {
    constructor() {
        super("backend.v1.SaveFamilyResponse", [
            { no: 1, name: "document", kind: "message", T: () => FamilyDocument },
            { no: 2, name: "plan_job", kind: "message", T: () => PlanJob }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message backend.v1.SaveFamilyResponse
 */
export const SaveFamilyResponse = new SaveFamilyResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VersionConflict$Type extends MessageType<VersionConflict> {
    constructor() {
        super("backend.v1.VersionConflict", [
            { no: 1, name: "current", kind: "message", T: () => FamilyDocument }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message backend.v1.VersionConflict
 */
export const VersionConflict = new VersionConflict$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ValidationFailure$Type extends MessageType<ValidationFailure> {
    constructor() {
        super("backend.v1.ValidationFailure", [
            { no: 1, name: "errors", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => FieldError },
            { no: 2, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message backend.v1.ValidationFailure
 */
export const ValidationFailure = new ValidationFailure$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FamilyDefaultsResponse$Type extends MessageType<FamilyDefaultsResponse> {
    constructor() {
        super("backend.v1.FamilyDefaultsResponse", [
            { no: 1, name: "resolved_family", kind: "message", T: () => Family },
            { no: 2, name: "defaulted_paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "default_changes", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => DefaultChange },
            { no: 4, name: "validation_errors", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => FieldError },
            { no: 5, name: "engine_created_paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "family_version", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message backend.v1.FamilyDefaultsResponse
 */
export const FamilyDefaultsResponse = new FamilyDefaultsResponse$Type();
